export const BNPL_PSEUDO_PAYMENT_OPTION = {
	name: 'bnpl',
	displayName: 'BNPL',
	valueOf: () => 'bnpl',
};
